import { render } from "./matching-ribbon.vue?vue&type=template&id=2130ba2e&scoped=true&ts=true"
import script from "./matching-ribbon.vue?vue&type=script&lang=ts"
export * from "./matching-ribbon.vue?vue&type=script&lang=ts"

import "./matching-ribbon.vue?vue&type=style&index=0&id=2130ba2e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2130ba2e"]])

export default __exports__